import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Container, Header, Footnote, Anchor } from 'Components/core';
import { colors } from 'Constants';

import InfoBox from 'Components/InfoBox';

// Images

// State
import { Subscribe } from 'laco-react';
import { ApiStore } from 'Store';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { replaceAnchor } from 'Root/libs/anchor';
import { toArray } from 'Root/libs/array';
import { SubHeader, TitleHeader } from 'Components/core/Header';

const EligibleColumn=styled.div`
flex:1;
margin-right:10px ;

`;

const EligibleTitle=styled.div`
font-weight:bold ;
margin-bottom:10px ;
`;

const EligibleSection=styled.div`
display:flex;
justify-content:space-between ;
flex-wrap:wrap ;
@media (max-width: 412px) {
    flex-direction: column;
  
  }

`;

const EligibleText=styled.p`

li {
   line-height:1.5 ;
}

`;

export default () => {

  useEffect(()=>{
 
    Api.recordAcitity(CODES.Eligibility);
  },[]);

  return  (
    <Subscribe to={[ApiStore]}>
      {state => {
       
        return (
          <Container
            seperation="32px"
            column
            maxWidth
            style={{ margin: 'auto', padding: '32px' }}
          >
            <TitleHeader>Student 
              <SubHeader>Advantage 101</SubHeader>

            </TitleHeader>


          
            <InfoBox header={state.brandInfo?.name+" Student Advantage 101"}>
        
              <EligibleSection>
                {state?.asaCoverage?.eligible?.group && toArray(state?.asaCoverage?.eligible?.group).map(item=><EligibleColumn>
                  <EligibleTitle> {item.title} </EligibleTitle>
                  <EligibleText dangerouslySetInnerHTML={{__html:item.information}}></EligibleText>

                </EligibleColumn>) }
              </EligibleSection>

              {state?.asaCoverage?.eligible.footNotes&& toArray(state?.asaCoverage?.eligible.footNotes).map(footnote=><Footnote>{footnote}</Footnote>) }     
 
            </InfoBox>
        
          </Container>
        );
      }}
    </Subscribe>
  );
};